module.exports = __webpack_public_path__ + "static/img/logo-keg.d0ed825.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/complete/logo-keg.png
// module id = 9LPI
// module chunks = 0